import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    color: theme.palette.labraText.primary,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    paddingBottom: theme.spacing(1),
    display: 'flex',
  },
  description: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    paddingBottom: theme.spacing(3),
  },
  textAreaWithChip: {
    width: '100%',
  },
  button: {
    float: 'right',
    paddingTop: theme.spacing(2),
  },
  noteSpacing: {
    paddingBottom: theme.spacing(2),
  },
  fullWidth: {
    width: '100%',
  },
}))
